import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/MonthlyInfluenceV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluenceV2-index" */ '~/pages/MonthlyInfluenceV2/pages/index'
        )
    ),
  },
  {
    path: '/MonthlyInfluenceV2/reward',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluenceV2-reward" */ '~/pages/MonthlyInfluenceV2/pages/reward'
        )
    ),
  },
  {
    path: '/MonthlyInfluenceV2/honor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluenceV2-honor" */ '~/pages/MonthlyInfluenceV2/pages/honor'
        )
    ),
  },
  {
    path: '/MonthlyInfluenceV2/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluenceV2-rule" */ '~/pages/MonthlyInfluenceV2/pages/rule'
        )
    ),
  },
] as RouteConfig[]
